import React from 'react';
import { observer } from 'mobx-react';

import AddEditStore from './DoctorDetailsStore';
import Modal from '../../../shared/Modal';
import UserUpdateHistory from '../../../admin-routes/UserUpdateHistory';

@observer
class ModalUserUpdateHistory extends React.Component {
  render() {
    const { open } = AddEditStore;
    return (
      <Modal visible={open} width={1200} onCancel={AddEditStore.toggleModal(false)} title="Account Update History">
        <UserUpdateHistory userId={AddEditStore.userId} username={AddEditStore.dataDoctor.Username} type={3} />
      </Modal>
    );
  }
}

export default ModalUserUpdateHistory;
